import script from "./UniqueAsYouMobileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UniqueAsYouMobileCard.vue?vue&type=script&setup=true&lang=js"

import "./UniqueAsYouMobileCard.vue?vue&type=style&index=0&id=3e133be4&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e133be4"]])

export default __exports__